import { Component, ViewEncapsulation, ChangeDetectionStrategy, AfterViewInit, ElementRef } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { CommonModule } from '@angular/common';
import { OverlayContainer } from '@angular/cdk/overlay';


@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule
  ]
})
export class SpinnerComponent implements AfterViewInit {

  public isLoading$;

  constructor(public loader: LoaderService,
    private elementRef: ElementRef,

    private overlayContainer: OverlayContainer) {
    this.isLoading$ = this.loader.loading$;
  }

  ngAfterViewInit(): void {
    const overlayContainerElement =
      this.overlayContainer.getContainerElement();
    overlayContainerElement.appendChild(
      this.elementRef.nativeElement
    );
  }

}
